<template>
    <b-card no-body>
        <b-card-header>
            <span class="h5">
                ADITIVAR-CONTRATO -
                <strong>
                    {{ contrato.vcCodigoEstruturado }} -
                    {{ contrato.fornecedor ? contrato.fornecedor.nome : '' }}
                </strong>
                <b-badge variant="warning"></b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="numeroContrato">Contrato</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="contrato"
                                    v-model="contrato.vcCodigoEstruturado"
                                    v-mask="'AA###/##'"
                                    :disabled="true"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <label>Vigência início</label>
                        <date-picker
                            v-model="vigenciaInicio"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            :disabled="true"
                        ></date-picker>
                    </b-col>
                    <b-col sm="12" md="3">
                        <label>Vigência fim</label>
                        <date-picker
                            v-model="vigenciaFim"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            :disabled="true"
                        ></date-picker>
                    </b-col>
                    <b-col sm="12" md="4">
                        <label>Fornecedor</label>
                        <b-form-input
                            type="text"
                            id="fornecedor"
                            v-model="fornecedor"
                            :disabled="true"
                        ></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="5">
                        <b-form-group>
                            <label>Tipo aditivo <span v-if="isUsuarioUABS()" class="text-danger">*</span></label>
                            <multi-select
                                :options="tipoAditivoOptions"
                                :selected-options="tiposAditivoSelecionados"
                                @select="selecionar"
                                :isDisabled="aditivoSalvo"
                                @input.native="
                                    $v.tiposAditivoSelecionados.$touch()
                                "
                                :state="
                                    $v.tiposAditivoSelecionados.$error
                                        ? false
                                        : null
                                "
                            ></multi-select>
                            <b-form-invalid-feedback v-if="isUsuarioUABS() && $v.tiposAditivoSelecionados.$error">
                                O tipo aditivo é obrigatório para usuários UABS
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label for="processo">Processo <span class="text-danger">*</span></label>
                            <b-input-group>
                                <b-form-input
                                    v-mask="'############'"
                                    placeholder="Digite o número do processo"
                                    v-model="processoAditivo"
                                    :disabled="aditivoSalvo"
                                    @input.native="$v.processoAditivo.$touch()"
                                    :state="
                                        $v.processoAditivo.$error ? false : null
                                    "
                                ></b-form-input>
                                <!-- <b-input-group-append>
                                    <b-button
                                        variant="primary"
                                        @click="obterProcessoPorNumero()"
                                        title="Clique para pesquisar o processo"
                                        :disabled="aditivoSalvo"
                                    >
                                        <i class="fa fa-search"></i>
                                    </b-button>
                                </b-input-group-append> -->
                                <b-form-invalid-feedback
                                    >O código do processo é
                                    obrigatório</b-form-invalid-feedback
                                >
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <!-- <b-col sm="12" md="4">
                        <b-form-group>
                            <label for="interessado">Interessado GEDOC</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="interessado"
                                    v-model="interessadoGEDOC"
                                    :disabled="true"
                                    :state="
                                        $v.interessadoGEDOC.$error
                                            ? false
                                            : null
                                    "
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col> -->
                </b-row>
                <!-- <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label for="criadoPor">Criado por no GEDOC</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="criadoPor"
                                    v-model="criadoPorGEDOC"
                                    :disabled="true"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label for="unidade">Unidade GEDOC</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="unidade"
                                    v-model="unidadeGEDOC"
                                    :disabled="true"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row> -->
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Objeto do Aditivo</label>
                            <b-form-textarea
                                v-model="objetoContrato"
                                :disabled="aditivoSalvo"
                                :rows="3"
                                @input="$v.objetoContrato.$touch()"
                                :state="$v.objetoContrato.$error ? false : null"
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Informações adicionais<span class="text-danger">*</span></label>
                            <b-form-textarea
                                v-model="infosAdicionais"
                                :rows="3"
                                :disabled="aditivoSalvo"
                                :state="
                                    $v.infosAdicionais.$error ? false : null
                                "
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                >Informações adicionais são
                                obrigatórias</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="12">
                        <label for="tblItensContrato"
                            >Aditivos do contrato</label
                        >
                        <app-tabela
                            idTabela="tblItensContrato"
                            :itens="aditivosContrato"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                        </app-tabela>
                    </b-col>
                </b-row>
            </div>
        </b-card-body>
        <b-card-footer>
            <b-button variant="danger" @click.stop="voltar()" class="mr-1">
                <span> <i class="fa fa-history"></i> Voltar </span>
            </b-button>
            <b-button
                variant="primary"
                :disabled="desabilitarBtnSalvar || aditivoSalvo"
                @click.stop="confirmaSalvar()"
            >
                <i class="fa fa-save"></i> Salvar aditivo
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import ContratosServicos from '../ContratosServicos'
import AditivarContratoServicos from './AditivarContratoServicos'
import { tiposAditivo } from '../TiposAditivo'
import { MultiSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'

export default {
    components: {
        MultiSelect
    },

    data() {
        return {
            erros: [],
            contrato: {},
            vigenciaInicio: null,
            vigenciaFim: null,
            fornecedor: '',
            tipoAditivoOptions: tiposAditivo,
            tiposAditivos: [],
            tipoAditivo: '',
            processoAditivo: '',
            interessadoGEDOC: '',
            criadoPorGEDOC: '',
            unidadeGEDOC: '',
            objetoContrato: '',
            vcProcessoAditivo: '',
            infosAdicionais: '',
            aditivosContrato: [],
            tiposAditivoSelecionados: [],
            ultimoTipoAditivoSelecionado: {},
            aditivoSalvo: false,
            campos: [
                {
                    key: 'vcObjetoAditivo',
                    label: 'Objeto do aditivo',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'vcHistoricoAditivo',
                    label: 'Motivo do aditivo',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'tiposAditivo',
                    label: 'Tipo do aditivo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'vigencia',
                    label: 'Vigência',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        obterContrato() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterPorId(this.$route.params.contratoId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.preencheFormulario(response.data)
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        preencheFormulario(data) {
            this.contrato = data
            this.fornecedor = data.fornecedor.nome
            this.insereContratoOriginalTabelaAditivos()

            if (
                data.dtInicioVigencia != undefined &&
                data.dtFimVigencia != undefined
            ) {
                this.vigenciaInicio = this.$moment(
                    this.contrato.dtInicioVigencia
                ).format('DD/MM/YYYY')
                this.vigenciaFim = this.$moment(
                    this.contrato.dtFimVigencia
                ).format('DD/MM/YYYY')
            }
        },

        selecionar(itens, ultimoSelecionado) {
            this.tiposAditivoSelecionados = itens
            this.ultimoTipoAditivoSelecionado = ultimoSelecionado
            this.erros = []
            this.modificaPropiedadesObjetos(this.tiposAditivoSelecionados)
        },

        modificaPropiedadesObjetos(tiposAditivo) {
            this.tiposAditivo = []
            tiposAditivo.forEach((element) => {
                let tpAtv = {
                    idTipoAditivo: element.value,
                    vcDescTipoAditivo: element.text
                }
                this.tiposAditivo.push(tpAtv)
            })
        },

        // modificaNumeroProcesso() {
        //     if (this.processoAditivo.length < 12) {
        //         this.interessadoGEDOC = ''
        //         ;(this.criadoPorGEDOC = ''),
        //             (this.unidadeGEDOC = ''),
        //             (this.objetoContrato = '')

        //         if (this.erros.length > 0) {
        //             this.erros = []
        //         }
        //     }
        // },

        insereContratoOriginalTabelaAditivos() {
            let contratoParaAditivo = {
                vcObjetoAditivo: this.contrato.vcObjetoContrato,
                vcHistoricoAditivo: '',
                tiposAditivo: 'Contrato original',
                valor: this.contrato.nuValorGlobalContrato,
                vigencia: `${this.$moment(
                    this.contrato.dtInicioVigencia
                ).format('DD/MM/YYYY')}
                 a ${this.$moment(this.contrato.dtFimVigencia).format(
                     'DD/MM/YYYY'
                 )}`,
                situacao: this.contrato.situacaoContrato
            }
            this.aditivosContrato.push(contratoParaAditivo)
        },

        obterProcessoPorNumero() {
            if (this.processoAditivo.length == 12) {
                this.$store.dispatch('addRequest')
                AditivarContratoServicos.obterProcessoGedocPorNumero(
                    this.processoAditivo
                ).then((response) => {
                    if (response) {
                        if (response.success && response.data != null) {
                            this.interessadoGEDOC = response.data.nome
                            this.criadoPorGEDOC = response.data.cadastradoPor
                            this.unidadeGEDOC = response.data.unidade
                            this.objetoContrato = response.data.assunto
                            this.vcProcessoAditivo = response.data.id
                        } else {
                            this.erros.push('Processo não encontrado')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        procuraTipoAditivo(value) {
            return this.tiposAditivoSelecionados.find((x) => x.value == value)
        },

        verificaTiposAditivo() {
            this.erros = []
            if (
                this.tiposAditivoSelecionados.length > 3 ||
                (this.procuraTipoAditivo(2) && this.procuraTipoAditivo(4))
            ) {
                this.erros.push('Combinação incorreta dos Tipos de Aditivo!')
                return false
            }
            return true
        },

        confirmaSalvar() {
            if (this.verificaTiposAditivo()) {
                this.$store.dispatch('addRequest')
                let aditivoContrato = {
                    idContrato: this.contrato.idContrato,
                    vcProcessoAditivo: this.processoAditivo,
                    vcObjetoAditivo: this.objetoContrato,
                    vcHistoricoAditivo: this.infosAdicionais,
                    idSolicitante: 1,
                    usrLoginCadastro: this.$store.getters.usuario.login,
                    dtCadastro: this.$moment().format(),
                    AditivoTiposAditivo: this.tiposAditivo
                }

                AditivarContratoServicos.inserirAditivoContrato(
                    aditivoContrato
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.aditivoSalvo = true
                            this.$toast.success(
                                'Aditivo salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.irParaDetalhesAditivoContrato(
                                response.data.idContrato
                            )
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        irParaDetalhesAditivoContrato(idContrato) {
            this.erros = []
            this.$router.push({
                name: 'Contratos_Detalhar',
                params: {
                    contratoId: idContrato
                }
            })
        },

        voltar() {
            this.erros = []
            this.$router.push({
                name: 'Contratos_Detalhar',
                params: {
                    contratoId: this.$route.params.contratoId
                }
            })
        },

        // Métodos para verificar o tipo de usuário baseado nas regras de acesso
        isUsuarioUAJ() {
            // Verifica se o usuário tem acesso UAJ (Unidade de Apoio Jurídico)
            return this.$temAcessoView('CONT-UAJ')
        },

        isUsuarioUABS() {
            // Verifica se o usuário tem acesso UABS (Unidade de Apoio às Bases de Serviços)
            return this.$temAcessoView('CONT-UABS')
        }
    },

    created() {
        this.obterContrato()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        }
    },

    validations: {
        objetoContrato: {
            // Removida obrigatoriedade do objeto do aditivo
        },
        processoAditivo: {
            required
        },
        tiposAditivoSelecionados: {
            required() {
                // UABS: tipo aditivo obrigatório
                if (this.isUsuarioUABS()) {
                    return this.tiposAditivoSelecionados && this.tiposAditivoSelecionados.length > 0
                }
                return true
            }
        },
        infosAdicionais: {
            required
        }
    }
}
</script>
